// Model: Application data and constants
export const AppConstants = {
  APP_NAME: "Inbox Zero AI",
  APP_DESCRIPTION:
    "Manage your inbox with AI, optimize your mails, and live a more focused life. Become more productive every day with personalized summaries and smart drafts.",
  CONTACT_EMAIL: "boby@boby.ai",
  COMPANY_NAME: "Bobby AI",
};

export const FeatureData = [
  {
    id: 1,
    title: "Smart Email Summaries",
    description:
      "Uses AI to extract the most important information from your emails instantly",
    icon: "📬",
    color: "indigo",
  },
  {
    id: 2,
    title: "Priority Inbox",
    description:
      "Automatically highlights urgent or action-required emails so you don’t miss anything important",
    icon: "⚡",
    color: "red",
  },
  {
    id: 3,
    title: "Multilingual Support",
    description:
      "Summarizes emails in multiple languages and translates key points for global communication",
    icon: "🌍",
    color: "green",
  },
  {
    id: 4,
    title: "Privacy-First Design",
    description:
      "Summaries are generated locally or encrypted before processing to ensure your data stays private",
    icon: "🔐",
    color: "gray",
  },
];
export const TestimonialData = [
  {
    id: 1,
    name: "Sarah L.",
    role: "Marketing Manager",
    content:
      "This app saves me hours every week. I get the key points from dozens of emails without reading them all.",
    rating: 5,
  },
  {
    id: 2,
    name: "James T.",
    role: "Freelance Consultant",
    content:
      "Client communication is now way easier. I can quickly scan summaries and respond faster.",
    rating: 5,
  },
  {
    id: 3,
    name: "Elena R.",
    role: "Startup Founder",
    content:
      "As someone who gets hundreds of emails daily, this tool is a game changer. Clean, fast, and smart.",
    rating: 5,
  },
];

export const PricingData = [
  {
    id: 1,
    name: "Basic",
    price: "Free",
    features: [
      "Summarize up to 20 emails/month",
      "Support for Gmail and Outlook",
      "Basic summary quality",
      "7-day summary history",
    ],
    recommended: false,
  },
  {
    id: 2,
    name: "Premium",
    price: "$10/month",
    features: [
      "Unlimited email summaries",
      "Priority & actionable email detection",
      "Multilingual support",
      "Advanced summary quality",
      "30-day summary history",
      "Custom notification settings",
    ],
    recommended: true,
  },
  {
    id: 3,
    name: "Pro",
    price: "$20/month",
    features: [
      "All Premium features",
      "Team & workspace support",
      "API access for integrations",
      "Downloadable summary reports",
      "Real-time AI assistant for inbox",
      "Dedicated customer support",
    ],
    recommended: false,
  },
];
